import { z } from "zod";

export const shelfFormSchema = z
  .object({
    name: z.string().min(1, "Please enter a shelf name."),
    brand_name: z.string().min(1, "Please enter a brand name."),
    description: z.string(),
    category: z
      .number({ message: "Please select a category for this shelf." })
      .min(1, "Please select a category for this shelf."),
    keywords: z
      .string()
      .array()
      .min(1, "Please select between 1 and 10 keywords for this shelf.")
      .max(10, "Please select between 1 and 10 keywords for this shelf."),
  })
  .passthrough();
